import { Controller } from "@hotwired/stimulus"

// A Turbo update or poll replaces the trail DOM. Keep only IDs and disclosure state between polls
// so existing summaries don't replay their arrival animation.
const histories = new Map()

export default class extends Controller {
  static targets = ["step", "disclosure"]
  static values = { key: String, running: Boolean }

  connect() {
    this.history = histories.get(this.keyValue) || { seen: new Map(), open: false, running: this.runningValue }
    if (this.history.running && !this.runningValue) this.history.open = false
    this.history.running = this.runningValue
    let arriving = 0
    this.stepTargets.forEach(step => {
      step.classList.remove("is-emerging", "is-settling")
      if (this.runningValue && !this.history.seen.has(step.dataset.stepId)) {
        step.classList.add("is-emerging")
        step.style.animationDelay = `${Math.min(arriving++, 3) * 90}ms`
      }
      if (this.history.seen.get(step.dataset.stepId) === "running" && step.dataset.state === "done") {
        step.classList.add("is-settling")
      }
      this.history.seen.set(step.dataset.stepId, step.dataset.state)
    })
    if (this.hasDisclosureTarget) this.disclosureTarget.open = this.history.open
    histories.set(this.keyValue, this.history)
    if (histories.size > 200) histories.delete(histories.keys().next().value)
  }

  remember() {
    if (!this.runningValue && this.hasDisclosureTarget) this.history.open = this.disclosureTarget.open
  }
}
